module.exports = __webpack_public_path__ + "img/85.58e2118e.jpg";